export default __webpack_public_path__ + "static/media/Pollarding.2b5730f1.jpg";